<div *ngIf="!messageFromQueryParams; else showMessage" id="notfound">
  <div class="notfound">
    <div class="notfound-404">
      <h3>{{ 'not_found.page_not_found' | translate }}</h3>
      <h1><span>4</span><span>0</span><span>4</span></h1>
    </div>
    <h2>{{ 'not_found.page_not_found_1' | translate }}</h2>
  </div>
</div>

<ng-template #showMessage>
  <div class="reason-container">
    <div class="reason-card">
      <div class="reason-icon">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
        </svg>
      </div>
      <h2 class="reason-title">Access Information</h2>
      <p class="reason-message">{{ messageFromQueryParams }}</p>
      <a routerLink="/" class="reason-button">Go to Homepage</a>
    </div>
  </div>
</ng-template>
